import { ICourseMapping, IValidator, IValidations } from '@/interfaces';

export class CourseMappingValidator implements IValidator<ICourseMapping> {
  public isValid(item: ICourseMapping) {
    const errors: IValidations<ICourseMapping> = {};
    // Validate email
    if (item.calendar === null) errors.calendar = ['Must select a calendar'];
    if (item.moodleCourse === null) errors.moodleCourse = ['Must select a moodle course'];
    return Object.keys(errors).length > 0 ? errors : true;
  }
}